<template>
    <div>
        <div v-if="usage == 'enquiries'" class="about-map-div">
            <GmapMap :center="center" :map-type-id="mapTypeId" :zoom="zoom">
                <GmapMarker v-for="(item, index) in markers" :key="index" :position="item.position" @click="center = item.position" :animation="1"
                    :icon="{ url: '/imgs/shijie_property_logo.png', scaledSize: {width: 100, height: 38},}"/>
            </GmapMap>
        </div>
        <div v-else>
            <div class="map-outer-div">
                <div class="details-map-div" v-if="active=='map' && category != 'INDUSTRIAL'">
                    <GmapMap :center="center" :map-type-id="mapTypeId" :zoom="zoom">
                        <GmapMarker v-for="(item, index) in markers" :key="index" :position="item.position" @click="center = item.position" :animation="1"
                            :icon="{ url: '/imgs/shijie_property_logo.png', scaledSize: {width: 100, height: 38},}"/>
                    </GmapMap>
                </div>
                <div class="details-map-div" v-else-if="active=='map'">
                    <GmapMap :center="center" :map-type-id="mapTypeId" :zoom="zoom"></GmapMap>
                </div>
                <div class="details-map-div" v-else>
                    <gmap-street-view-panorama class="vue-map-container" :position="center" :pov="pov" :zoom="1">
                        <GmapMarker v-for="(item, index) in markers" :key="index" :position="item.position" @click="center = item.position" :animation="1"
                            :icon="{ url: '/imgs/shijie_property_logo.png', scaledSize: {width: 100, height: 38},}"/>
                    </gmap-street-view-panorama>
                </div>
            </div>
            <button v-if="category != 'INDUSTRIAL' && active == 'map'" @click="active='pano'" class="details-map-btn">Click for Street View</button>
            <button @click="active='map'" class="details-map-btn" v-else>Click for Map View</button>
        </div>
    </div>
</template>

<script>
    //:icon="{ url: require('../../assets/img/marker-a.png')}" put this in GmapMarker for custom marker
    export default {
        name: 'static-map',
        props: ['lat', 'lng', 'maptype', 'usage', 'category'],
        data() {
            return {
                zoom: 16,
                center: {
                    lat: this.lat,
                    lng: this.lng
                },
                mapTypeId: this.maptype,
                markers: [{
                    position: {
                        lat: this.lat,
                        lng: this.lng
                    }
                }],
                pov: {
                    heading: 0,
                    pitch: 0
                },
                active: 'map',
            };
        },
        method: {
            updatePano: function () {
                console.log('updated pano')
            },
            updatePov: function () {
                console.log('updated pov')
            }
        }
    };
</script>

<style lang="scss" scoped>
    .map-outer-div {
        margin-top: 10px;
        width: 100%;
        position: relative;
        padding-top: 56.25%;
    }

    .details-map-div {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .details-map-btn {
        margin-top: 10px;
        border: none;
        background: none;
        color: #D80000;
    }
</style>